export default __webpack_public_path__ + "static/media/profile-pencil-icon.0d4fd136.svg";